import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="w-full bg-background-100 border-t border-background-200">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-16">
        <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 md:px-12 py-10 md:py-14">
          <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-primary-500/40"></div>
          <div className="absolute -right-4 bottom-0 w-32 h-32 rounded-full bg-accent-500/20"></div>
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
            <div className="max-w-xl">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                别让后续更新从指缝里溜走
              </h2>
              <p className="mt-3 text-sm md:text-base text-primary-100 leading-relaxed">
                进入事件合集，按话题跟进展；带「持续更新中」的合集会在有新进展时补齐时间线，你只看新增部分就够了。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <Link
                to="/collections"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-compasses-2-line"></i>
                开始浏览合集
              </Link>
              <Link
                to="/about#contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-primary-200/60 text-background-50 text-sm font-medium hover:bg-primary-500 transition-colors whitespace-nowrap"
              >
                <i className="ri-chat-3-line"></i>
                联系与反馈
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}